var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tick-circle",
    d: "M12,22A10,10,0,1,0,2,12,10,10,0,0,0,12,22ZM8.293,11.293a1,1,0,0,1,1.414,0L11,12.586l3.293-3.293a1,1,0,1,1,1.414,1.414l-4,4a1,1,0,0,1-1.414,0l-2-2a1,1,0,0,1,0-1.414Z",
    transform: "translate(-2 -2)",
    fill: "#2ac135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.45c0ce1f2cefa76943ebaffe4030d0a8.svg";
export { ForwardRef as ReactComponent };